"use strict";

exports.__esModule = true;
exports.ActionButtonWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ActionButtonElement = require("./ActionButtonElement");
var _ActionButtonFields = require("./ActionButtonFields");
var _ActionButtonHeader = require("./ActionButtonHeader");
var _ActionButtonThumbnail = require("./ActionButtonThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ActionButtonWidget = exports.ActionButtonWidget = {
  name: "ActionButton",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ActionButtonWidget.label",
    defaultMessage: "Action Button"
  }),
  icon: "label",
  group: _widgetGroups.ACTION_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "ActionButton",
      props: Object.assign({
        width: 256,
        height: 64,
        flex: 1,
        fontSize: 32,
        name: "AddPartCount",
        selected: "AddPartCount",
        label: ""
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height", "content"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 100,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _ActionButtonHeader.ActionButtonHeader,
    Element: _ActionButtonElement.ActionButtonElement,
    Fields: _ActionButtonFields.ActionButtonFields,
    Thumbnail: _ActionButtonThumbnail.ActionButtonThumbnail
  }
};